<template>
  <h2 class="pl_headline100 pl_headline200--lg">
    <slot></slot>
  </h2>
</template>
